/* tslint:disable */

/**
 * Integrations API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Re-usable object for validating the ID of an entity
 * @export
 * @interface Id
 */
export interface Id {
  /**
   * The id of an entity
   * @type {number}
   * @memberof Id
   */
  id?: number;
}

/**
 * Instance of an integration
 * @export
 * @interface Integration
 */
export interface Integration<O = unknown> {
  /**
   * The id of an entity
   * @type {number}
   * @memberof Integration
   */
  id: number;
  /**
   * Owner of the integration
   * @type {string}
   * @memberof Integration
   */
  owner: string;
  /**
   * Name of the integration
   * @type {string}
   * @memberof Integration
   */
  name: string;
  /**
   * Id of the integration template, if any
   * @type {number}
   * @memberof Integration
   */
  templateId?: number;
  /**
   * Additional options of the integration
   * @type {{ [key: string]: object; }}
   * @memberof Integration
   */
  options?: O;
  /**
   * True if the integration is in testing
   * @type {boolean}
   * @memberof Integration
   */
  testMode?: boolean;
  /**
   * State of the integration
   * @type {string}
   * @memberof Integration
   */
  state?: IntegrationStateEnum;
}

export enum IntegrationCategoryEnum {
  CustomLimitation = 'customLimitation',
  Push = 'push',
  SSO = 'sso',
}

/**
 * @export
 * @enum {string}
 */
export enum IntegrationStateEnum {
  Active = 'ACTIVE',
  Disabled = 'DISABLED',
  Deleted = 'DELETED',
}
